<template>
  <span>
    <slot :scope="scope"></slot>
  </span>
</template>
<script>
export default {
  name: 'LayuiExportExcel',
  props: {
    requestUniqueId: {
      type: String, // // 请求唯一标识，必须有
      default: () => {
        return 'LayuiExportExcel-' + window.uuid()
      }
    },
    templateName: {
      type: String
    },
    tableName: {
      type: String,
      default: ''
    },
    url: {
      type: String
    },
    fileName: {
      type: String
    },
    model: {
      type: Object
    }
  },
  data() {
    return {
      id: null,
      scope: this,
      exportUrl: process.env.API_HOST + '/export/excel/' + this.requestUniqueId
    }
  },
  mounted() {
    var element = (this.el = $(this.$el))
    var id = (this.id = this.uuid())
    this._templateName = this.templateName
  },
  methods: {
    setTemplateName(tname) {
      this._templateName = tname
    },
    export(tableObj) {
      debugger
      this.exportUrl = process.env.API_HOST + '/export/excel/' + this.requestUniqueId
      if (!this._templateName) {
        this.layer.openAlert('未设置模板名称！')
        return
      }
      this.layer.openConfirm('如果导出数据比较多，可能需要等待一段时间！', () => {
        this.layer.openMsg('正在导出，请等待导出完成，不要重复操作', { time: 5000 })
        var formHtml =
          '<form  method="post" action="' +
          (this.url ? this.url : this.exportUrl) +
          '" style="display:none;" accept-charset="UTF-8">'
        var base64 = new Base64()
        var p2 = $.extend(true, {}, tableObj.defaultCondition, tableObj.queryObject)
        p2 = this.api.parseP2(p2)
        if (tableObj.viewName && this.tableName === '') {
          this.tableName = tableObj.viewName
        }
        var args = {
          token: this.security.getToken(),
          tableName: base64.encode(this.tableName ? this.tableName : tableObj.tableName),
          templateName: base64.encode(this._templateName),
          fileName: this.fileName ? base64.encode(this.fileName) : '',
          model: this.model ? base64.encode(JSON.stringify(this.model)) : '',
          condition: base64.encode(
            JSON.stringify({
              p1: this.tableName ? this.tableName : tableObj.tableName,
              p2: p2,
              p9: tableObj.selectFields,
              p10: tableObj.sort,
              p11: tableObj.unSelectFields
            })
          )
        }
        for (var key in args) {
          var value = args[key]
          if (value) {
            if (typeof value == 'object') {
              value = JSON.stringify(value)
            }
            if (typeof value == 'string') value = value.replace(/\"/g, '&quot;')
            formHtml += '<input type="hidden" name="' + key + '" value="' + value + '">'
          }
        }
        formHtml += '</form>'
        $(formHtml)
          .appendTo($('body'))
          .submit()
      })
    },
    //firstCol需要合并的首列，lastCol需要合并的最后一列 keyWord判断相等需要合并的关键词
    margeExport(tableObj) {
      this.exportUrl = process.env.API_HOST + '/export/margeExportExcel/' + this.requestUniqueId
      if (!this._templateName) {
        this.layer.openAlert('未设置模板名称！')
        return
      }
      this.layer.openConfirm('如果导出数据比较多，可能需要等待一段时间！', () => {
        this.layer.openMsg('正在导出，请等待导出完成，不要重复操作', { time: 5000 })
        var formHtml =
          '<form  method="post" action="' +
          (this.url ? this.url : this.exportUrl) +
          '" style="display:none;" accept-charset="UTF-8">'
        var base64 = new Base64()
        var p2 = $.extend(true, {}, tableObj.defaultCondition, tableObj.queryObject)
        p2 = this.api.parseP2(p2)
        var args = {
          token: this.security.getToken(),
          tableName: base64.encode(this.tableName ? this.tableName : tableObj.tableName),
          templateName: base64.encode(this._templateName),
          fileName: this.fileName ? base64.encode(this.fileName) : '',
          model: this.model ? base64.encode(JSON.stringify(this.model)) : '',
          condition: base64.encode(
            JSON.stringify({
              p1: this.tableName ? this.tableName : tableObj.tableName,
              p2: p2,
              p9: tableObj.selectFields,
              p10: tableObj.sort,
              p11: tableObj.unSelectFields
            })
          ),
          firstCol: base64.encode(tableObj.firstCol ? tableObj.firstCol : '0'),
          lastCol: base64.encode(tableObj.lastCol ? tableObj.lastCol : '0'),
          keyWord: base64.encode(tableObj.keyWord ? tableObj.keyWord : '')
        }
        for (var key in args) {
          var value = args[key]
          if (value) {
            if (typeof value == 'object') {
              value = JSON.stringify(value)
            }
            if (typeof value == 'string') value = value.replace(/\"/g, '&quot;')
            formHtml += '<input type="hidden" name="' + key + '" value="' + value + '">'
          }
        }
        formHtml += '</form>'
        $(formHtml)
          .appendTo($('body'))
          .submit()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiExportExcel.vue